import { SchemaVersions, JOB_SCHEMA_VERSIONS } from '../ManifestModel';

export function isValidManifestVersion(item: unknown): item is SchemaVersions {
  if (typeof item === 'string') {
    return JOB_SCHEMA_VERSIONS.includes(item);
  }

  return false;
}
